/*
 * @Author: liyihui
 * @Date:
 * @description:  接口请求访问地址 产品服务、首页部分、联系我们相关内容
 * @Last Modified by:
 * @Last Modified time:
 */

import { gwManageGET, gwManagePOST, gwManagePUT, gwManageDEL } from './index';

// 获取导航栏
function getNavbar(data, func) {
	gwManagePOST('queryNavibarList', data, func);
}
// 获取banner图
function getBannerPicture(data, func) {
	gwManagePOST('queryCarouselPicturesList', data, func);
}
// 获取产品服务介绍
function getProductIntroduce(data, func) {
	gwManagePOST('queryConvertProductCopywritingList', data, func);
}
// 获取产品服务
function getProductList(data, func) {
	gwManagePOST('findProjectByClientlist', data, func);
}
// 查询合作伙伴列表
function getPartnerList(data, func) {
	gwManagePOST('queryPartnerList', data, func);
}
// 查询企业信息
function getEnterpriceInfo(data, func) {
	gwManagePOST('queryCompanyList', data, func);
}
// 查询友情链接列表
function getLinksList(data, func) {
	gwManagePOST('queryFriendshipLinksList', data, func);
}
// 查询二维码配置列表
function getQrcodeList(data, func) {
	gwManagePOST('queryQrcodeList', data, func);
}
// 查询附属企业列表
function queryAffiliatedCompany(data, func) {
	gwManagePOST('queryAffiliatedCompanyList', data, func);
}


const API = {
	getNavbar,
	getBannerPicture,
	getProductIntroduce,
	getProductList,
	getPartnerList,
	getEnterpriceInfo,
	getLinksList,
	getQrcodeList,
	queryAffiliatedCompany,
};

export default API;



// WEBPACK FOOTER //
// ./src/api/gwManage/product.js